import SectionTitle from '@/components/feature/SectionTitle';
import DramaCard from '@/components/feature/DramaCard';
import { dramas, mainDramaId } from '@/mocks/dramas';

export default function HotDramas() {
  const list = dramas.filter((d) => d.id !== mainDramaId).slice(0, 4);

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <SectionTitle
          eyebrow="同类型好剧"
          title="看过《迷人的保姆》，还可以看看这些"
          description="同样聚焦家庭、都市与情感题材，风格相近，适合喜欢温暖叙事的你。"
          linkTo="/category"
          linkLabel="进入剧集分类"
        />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {list.map((drama) => (
            <DramaCard key={drama.id} drama={drama} />
          ))}
        </div>
      </div>
    </section>
  );
}